import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const Banner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  background-color: ${colors.orange3};
  color: ${colors.white};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 500;

  > p {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;

    &::before {
      content: url(/images/warning-circle-orange.svg);
      height: 15px;
      width: 15px;
      margin-right: 7px;
    }
  }

  > button {
    background-color: ${colors.orange3};
    border: 1px solid ${colors.white};
    border-radius: 3px;
    padding: 2px 12px;
    margin-left: 10px;
  }
`;

export const BannerGreenCheckMark = styled(Banner)`
  background-color: ${colors.green5};

  > p {
    &::before {
      content: url(/images/check-mark-white-filled.svg);
    }
  }

  > button {
    background-color: ${colors.green5};
  }
`;
